
import { Component, Vue, Prop, Watch } from "vue-property-decorator"
import { MonthPicker, MonthPickerEvent } from "vue-month-picker"

import { Getter } from "vuex-class"

import moment from "moment"

import { BvEvent } from "bootstrap-vue"
import { asUtc, asLocal } from "@/scripts/defaultTimezone"

@Component({
	components: {
		"month-picker": MonthPicker
	}
})
export default class MonthPickerControl extends Vue {
	@Prop({ type: [String, Date], default: () => null })
	value!: string | Date | null

	@Prop({ type: String, default: "Select Month" })
	buttonText!: string | null

	@Prop({ type: [String, Date], default: () => null })
	minDate!: string | Date | null

	@Prop({ type: [String, Date], default: () => null })
	maxDate!: string | Date | null

	@Prop({ type: Boolean, default: false })
	isEndMonth!: boolean | null

	@Prop({ type: Boolean, default: false })
	useSmallButton!: boolean | null

	@Getter getDarkMode!: boolean;

	modalOpen: boolean = false

	keyDownListenerEsc = (e: KeyboardEvent) => {
		if (e.key === "Escape") {
			this.close()
		}
	}

	get minDateValue () : Date | null {
		if (this.minDate) {
			return moment.utc(this.minDate).toDate()
		}
		return null
	}

	get maxDateValue () : Date | null {
		if (this.maxDate) {
			const localMax = asLocal(this.maxDate)
			if (localMax.getMonth() !== moment(this.value!).month()) {
				return localMax
			}
		}
		return null
	}

	get selectedMonth () : number | null {
		if (this.value) {
			if (!this.isEndMonth) {
				return moment.utc(this.value).month() + 1
			} else {
				return moment.utc(this.value).month() + 1
			}
		}

		return moment().month() + 1
	}

	get selectedMonthLabel () : string | null {
		if (this.value) {
			return moment.utc(this.value).format("MMMM YYYY")
		}
		return null
	}

	get selectedYear () : number | null {
		if (this.value) {
			return moment.utc(this.value).year()
		}
		return moment().year()
	}

	open (event: BvEvent) {
		event.target.blur()

		this.modalOpen = true

		window.addEventListener("keydown", this.keyDownListenerEsc)
	}

	close () {
		this.modalOpen = false

		window.removeEventListener("keydown", this.keyDownListenerEsc)
	}

	monthChanged (newMonth: MonthPickerEvent) {
		if (!this.isEndMonth) {
			this.$emit("monthChanged", asUtc(newMonth.from))
		} else {
			this.$emit("monthChanged", asUtc(newMonth.to))
		}
		this.close()
	}
}
